import { render } from "./AdminCard.vue?vue&type=template&id=066f9e92&scoped=true"
import script from "./AdminCard.vue?vue&type=script&lang=js"
export * from "./AdminCard.vue?vue&type=script&lang=js"

import "./AdminCard.vue?vue&type=style&index=0&id=066f9e92&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066f9e92"]])

export default __exports__